export const ADMIN_FILTERS_KEY = {
  userFilter: 'user.username',
  verificationUserFilter: 'verificationUserUsername',
  verificatedAtFilter: 'verificatedAt',
  verificationUpdatedAtFilter: 'verificationUpdatedAt',
  updateUserUsernameFilter: 'updateUserUsername',
  lotAuthorUserFilter: 'lotAuthorUserUsername',
  producerFilter: 'wine.tradeName',
  wineCountryFilter: 'wine.country',
  productCountryFilter: 'product.wine.country',
  diffFieldsFilter: 'diffFields',
  factsDiffFieldsFilter: 'factsDiffFields',
  productBrandFilter: 'product.wine.brand',
  statusFilter: 'status',
  tradeNameFilter: 'product.wine.tradeName',
  verificationFilter: 'companyVerification',
  categoryFilter: 'companyCategory',
  stripeIdStatusFilter: 'haveELabelStripeCustomerId',
  createdAtFilter: 'createdAt',
  aiWineDateFilter: 'modelWineTimestamp',
  updatedAtFilter: 'updatedAt',
  expertQualificationFilter: 'expertQualification',
  permissionFilter: 'permission',
  expertVerificationStatusFilter: 'expertVerificationStatus',
  userStatusFilter: 'status',
  merchantFilter: 'merchant.name',
  nationalGITypeFilter: 'product.wine.nationalGIType',
  wineRegionEUFilter: 'product.wine.wineRegionEU',
  specialClassificationFilter: 'product.wine.specialClassification',
  geoIndicationFilter: 'product.wine.geoIndication',
  wineTypeFilter: 'product.wine.wineType',
  wineColourFilter: 'product.wine.wineColor',
  sweetnessTypeFilter: 'product.wine.sweetnessLevel',
  vintageFilter: 'product.wine.vintage',
  bottleSizeFilter: 'product.bottleSize',
  packageTypeFilter: 'product.packageType',
  uniqueProductURLFilter: 'isProductURLUnique',
  frontLabelFilter: 'hasFrontLabelImage',
  backLabelFilter: 'hasBackLabelImage',
  packshotFilter: 'hasBottleImage',
  eshopCountryFilter: 'merchant.country',
  alcoholLevelFilter: 'chemicalAnalysisAlcohol',
  wineLotFilter: 'wineLot',
  vatBehaviorFilter: 'vatBehavior',
  purchaseConditionFilter: 'purchaseCondition',
  deliveryCostFilter: 'deliveryCost',
  lotCreatedAtFilter: 'lotCreatedAt',
  isProductSetFilter: 'isProductSet',
  isMerchantSetFilter: 'isMerchantSet',
  merchantCountryFilter: 'country',
  deliveryTimeFilter: 'deliveryTime',
  parsingFilter: 'parsingEnabled',
  isEshopFilter: 'isEShop',
  invalidRecordFilter: 'product.invalidRecord',
  isWineSetFilter: 'isWineSet',
  additionalNameFilter: 'product.wine.keywords',
  withAdditionalNameFilter: 'product.wine.keywordsExists',
  confidenceFilter: 'modelConfidence',
  modelFactsConfidenceFilter: 'modelFactsConfidence',
  isModelWineSetFilter: 'isModelWineSet',
  userWineFilter: 'isUserWineSet',
  authorUserRoleFilter: 'userWineAuthorUserRole',
  isModelUserWineMatchFilter: 'isModelUserWineMatch',
  modelVersionFilter: 'modelVersion',
  pendingVerificationStepFilter: 'pendingVerificationStep',
  clusterMentionFilter: 'actualClusterSize',
  invalidEntityFilter: 'invalidEntity',
  hasVerifiedRepresentativeFilter: 'product.hasVerifiedRepresentative',
  hasBottleImageFilter: 'product.hasBottleImage',
  hasFrontLabelImageFilter: 'product.hasFrontLabelImage',
  hasBackLabelImageFilter: 'product.hasBackLabelImage',
  alcoholOnLabelFilter: 'product.alcoholOnLabel',
  certificatesFilter: 'product.wine.certification',
  sourceFilter: 'source',
  destinationSourceFilter: 'destinationSource',
  authorUserFilter: 'authorUserUsername',
  lastUpdateUserFilter: 'updateUserUsername',
  allCheckedFilter: 'allStepsCompleted',
  checkedStepsFilter: 'completedVerificationStep',
  kindOfWineFilter: 'geoIndicationCondition',
  rightnessFilter: 'rightness',
  identificationFilter: 'identificationState',
  isPrivilegedFilter: 'isPrivileged',
  relationTypeFilter: 'relationType',
  isModelDisagreeFilter: 'disagreeModels',
  hasImagesFilter: 'hasImages',
  mentionImages: 'mentionImages',
  conflictsFilter: 'conflictType',
  conflictMinConfidenceFilter: 'conflictMinConfidence',
  onlyOldFilter: 'verificationKeyMode',
  differentVintagesFilter: 'differentVintages',
  userEntitiesFilter: 'userEntityNames',
  modelTradeOfferConfidenceFilter: 'modelTradeOfferConfidence',
  modelTradeOfferVersionFilter: 'modelTradeOfferVersion',
  aiRetailOffersFilter: 'isModelTradeOfferSet',
  userRetailOffersFilter: 'isUserTradeOfferSet',
  hasTradeOfferDifferenceFilter: 'hasTradeOfferDifference',
  anomalyFilter: 'hasPricesAnomaly',
  userTradeOfferUsernameFilter: 'userTradeOfferUsername',
  tradeOfferVerificatedAtFilter: 'tradeOfferVerificatedAt',
  retailOfferStatusFilter: 'retailOfferStatus',
  retailOfferSizeFilter: 'retailOfferBottleSize',
  retailOfferPackageTypeFilter: 'retailOfferPackageType',
  retailOfferWineLotFilter: 'retailOfferWineLot',
  retailOfferVatBehaviorFilter: 'retailOfferVatBehavior',
  retailOfferPurchaseConditionFilter: 'retailOfferPurchaseCondition',
  retailOfferDeliveryCostFilter: 'retailOfferDeliveryCost',
  retailOfferVintageFilter: 'retailOfferVintage',
  retailOfferCountFilter: 'retailOfferCount',
  retailOfferPriceTypeFilter: 'retailOfferPriceType',
  suspiciousStatusFilter: 'suspiciousStatus',
  suspiciousBottleSizeFilter: 'suspiciousBottleSize',
  suspiciousPackageTypeFilter: 'suspiciousPackageType',
  suspiciousWineLotFilter: 'suspiciousWineLot',
  suspiciousPriceFilter: 'suspiciousPrice',
  suspiciousCurrencyFilter: 'suspiciousCurrency',
  suspiciousPriceTypeFilter: 'suspiciousPriceType',
  suspiciousVatBehaviorFilter: 'suspiciousVatBehavior',
  suspiciousPurchaseConditionFilter: 'suspiciousPurchaseCondition',
  suspiciousDeliveryCostFilter: 'suspiciousDeliveryCost',
  suspiciousVintageFilter: 'suspiciousVintage',
  suspiciousOfferCountFilter: 'suspiciousOfferCount',
  variousQuantitiesFilter: 'variousQuantities',
  suspiciousScreenValidityFilter: 'suspiciousScreenValidity',
  validScreenFilter: 'validScreen',
  onlyLatestMentionFilter: 'onlyLatestMention',
  invalidReasonFilter: 'invalidReason',
  modelNewLotsFilter: 'modelNewLots',
  userNewLotsFilter: 'userNewLots',
  userPriceFilter: 'userPrice',
  modelPriceFilter: 'modelPrice',
  pricePerFilter: 'priceType',
  wineSiteTypeFilter: 'wineSiteType',
  multiCountryFilter: 'isMultiCountry',
  multiCurrencyFilter: 'isMultiCurrency',
  isStockQuantitySetFilter: 'isStockQuantitySet',
  aiFactsFilter: 'isModelFactsSet',
  userFactsFilter: 'isModeratorFactsSet',
  grapesFactFilter: 'actualFactsGrape',
  alcoholFactFilter: 'actualFactsAlcoholOnLabel',
  certsFactFilter: 'actualFactsCert',
  awardsFactFilter: 'actualFactsAward',
  factVintageFilter: 'vintages',
  factSizeFilter: 'bottleSizes',
  factPackageTypesFilter: 'packageTypes',
  modelFactsCreatedAtFilter: 'modelFactsCreatedAt',
  moderatorFactsUsernameFilter: 'moderatorFactsUsername',
  moderatorFactsCreatedAtFilter: 'moderatorFactsCreatedAt',
  canonicalLinkFilter: 'isCanonical',
  isNotOkSnapshotFilter: 'isNotOkSnapshot',
}

export const ADMIN_FILTERS_NAME = {
  userFilter: 'usersFilter',
  verificationUserFilter: 'verificationUserFilter',
  verificatedAtFilter: 'verificatedAtFilter',
  updateUserUsernameFilter: 'updateUserUsernameFilter',
  lotAuthorUserFilter: 'lotAuthorUserFilter',
  producerFilter: 'producerFilter',
  tradeNameFilter: 'tradeNameFilter',
  wineCountryFilter: 'wineCountryFilter',
  diffFieldsFilter: 'diffFieldsFilter',
  statusFilter: 'statusFilter',
  verificationFilter: 'verificationStatusFilter',
  categoryFilter: 'companyCategoryFilter',
  stripeIdStatusFilter: 'haveELabelStripeCustomerIdFilter',
  createdAtFilter: 'createdAtFilter',
  aiWineDateFilter: 'aiWineDateFilter',
  lotCreatedAtFilter: 'lotCreatedAtFilter',
  updatedAtFilter: 'updatedAtFilter',
  expertQualificationFilter: 'expertQualificationFilter',
  permissionFilter: 'permissionFilter',
  expertVerificationStatusFilter: 'expertVerificationStatusFilter',
  userStatusFilter: 'userStatusFilter',
  merchantFilter: 'merchantFilter',
  productBrandFilter: 'productBrandFilter',
  nationalGITypeFilter: 'nationalGITypeFilter',
  wineRegionEUFilter: 'wineRegionEUFilter',
  specialClassificationFilter: 'specialClassificationFilter',
  geoIndicationFilter: 'geoIndicationFilter',
  wineTypeFilter: 'wineTypeFilter',
  wineColourFilter: 'wineColourFilter',
  sweetnessTypeFilter: 'sweetnessTypeFilter',
  vintageFilter: 'vintageFilter',
  bottleSizeFilter: 'bottleSizeFilter',
  packageTypeFilter: 'packageTypeFilter',
  uniqueProductURLFilter: 'uniqueProductURLFilter',
  frontLabelFilter: 'frontLabelFilter',
  backLabelFilter: 'backLabelFilter',
  packshotFilter: 'packshotFilter',
  eshopCountryFilter: 'eshopCountryFilter',
  alcoholLevelFilter: 'alcoholLevelFilter',
  wineLotFilter: 'wineLotFilter',
  vatBehaviorFilter: 'vatBehaviorFilter',
  purchaseConditionFilter: 'purchaseConditionFilter',
  deliveryCostFilter: 'deliveryCostFilter',
  isProductSetFilter: 'isProductSetFilter',
  isMerchantSetFilter: 'isMerchantSetFilter',
  merchantCountryFilter: 'merchantCountryFilter',
  deliveryTimeFilter: 'deliveryTimeFilter',
  parsingFilter: 'parsingFilter',
  isEshopFilter: 'isEshopFilter',
  invalidRecordFilter: 'invalidRecordFilter',
  isWineSetFilter: 'isWineSetFilter',
  additionalNameFilter: 'additionalNameFilter',
  withAdditionalNameFilter: 'withAdditionalNameFilter',
  confidenceFilter: 'confidenceFilter',
  isModelWineSetFilter: 'isModelWineSetFilter',
  userWineFilter: 'userWineFilter',
  authorUserRoleFilter: 'authorUserRoleFilter',
  isModelUserWineMatchFilter: 'isModelUserWineMatchFilter',
  modelVersionFilter: 'modelVersionFilter',
  pendingVerificationStepFilter: 'pendingVerificationStepFilter',
  clusterMentionFilter: 'clusterMentionFilter',
  invalidEntityFilter: 'invalidEntityFilter',
  hasVerifiedRepresentativeFilter: 'hasVerifiedRepresentativeFilter',
  hasBottleImageFilter: 'hasBottleImageFilter',
  hasFrontLabelImageFilter: 'hasFrontLabelImageFilter',
  hasBackLabelImageFilter: 'hasBackLabelImageFilter',
  alcoholOnLabelFilter: 'alcoholOnLabelFilter',
  certificatesFilter: 'certificatesFilter',
  sourceFilter: 'sourceFilter',
  destinationSourceFilter: 'destinationSourceFilter',
  authorUserFilter: 'authorUserFilter',
  lastUpdateUserFilter: 'lastUpdateUserFilter',
  allCheckedFilter: 'allCheckedFilter',
  checkedStepsFilter: 'checkedStepsFilter',
  kindOfWineFilter: 'kindOfWineFilter',
  productCountryFilter: 'productCountryFilter',
  rightnessFilter: 'rightnessFilter',
  identificationFilter: 'identificationFilter',
  isPrivilegedFilter: 'isPrivilegedFilter',
  relationTypeFilter: 'relationTypeFilter',
  isModelDisagreeFilter: 'isModelDisagreeFilter',
  hasImagesFilter: 'hasImagesFilter',
  mentionImages: 'mentionImages',
  conflictsFilter: 'conflictsFilter',
  conflictMinConfidenceFilter: 'conflictMinConfidenceFilter',
  onlyOldFilter: 'onlyOldFilter',
  differentVintagesFilter: 'differentVintagesFilter',
  userEntitiesFilter: 'userEntitiesFilter',
  modelTradeOfferConfidenceFilter: 'modelTradeOfferConfidenceFilter',
  modelTradeOfferVersionFilter: 'modelTradeOfferVersionFilter',
  aiRetailOffersFilter: 'aiRetailOffersFilter',
  userRetailOffersFilter: 'userRetailOffersFilter',
  hasTradeOfferDifferenceFilter: 'hasTradeOfferDifferenceFilter',
  anomalyFilter: 'anomalyFilter',
  userTradeOfferUsernameFilter: 'userTradeOfferUsernameFilter',
  tradeOfferVerificatedAtFilter: 'tradeOfferVerificatedAtFilter',
  retailOfferStatusFilter: 'retailOfferStatusFilter',
  retailOfferSizeFilter: 'retailOfferSizeFilter',
  retailOfferPackageTypeFilter: 'retailOfferPackageTypeFilter',
  retailOfferWineLotFilter: 'retailOfferWineLotFilter',
  retailOfferVatBehaviorFilter: 'retailOfferVatBehaviorFilter',
  retailOfferPurchaseConditionFilter: 'retailOfferPurchaseConditionFilter',
  retailOfferDeliveryCostFilter: 'retailOfferDeliveryCostFilter',
  retailOfferVintageFilter: 'retailOfferVintageFilter',
  retailOfferCountFilter: 'retailOfferCountFilter',
  retailOfferPriceTypeFilter: 'retailOfferPriceTypeFilter',
  suspiciousStatusFilter: 'suspiciousStatusFilter',
  suspiciousBottleSizeFilter: 'suspiciousBottleSizeFilter',
  suspiciousPackageTypeFilter: 'suspiciousPackageTypeFilter',
  suspiciousWineLotFilter: 'suspiciousWineLotFilter',
  suspiciousPriceFilter: 'suspiciousPriceFilter',
  suspiciousCurrencyFilter: 'suspiciousCurrencyFilter',
  suspiciousPriceTypeFilter: 'suspiciousPriceTypeFilter',
  suspiciousVatBehaviorFilter: 'suspiciousVatBehaviorFilter',
  suspiciousPurchaseConditionFilter: 'suspiciousPurchaseConditionFilter',
  suspiciousDeliveryCostFilter: 'suspiciousDeliveryCostFilter',
  suspiciousVintageFilter: 'suspiciousVintageFilter',
  suspiciousOfferCountFilter: 'suspiciousOfferCountFilter',
  variousQuantitiesFilter: 'variousQuantitiesFilter',
  suspiciousScreenValidityFilter: 'suspiciousScreenValidityFilter',
  validScreenFilter: 'validScreenFilter',
  onlyLatestMentionFilter: 'onlyLatestMentionFilter',
  invalidReasonFilter: 'invalidReasonFilter',
  modelNewLotsFilter: 'modelNewLotsFilter',
  userNewLotsFilter: 'userNewLotsFilter',
  userPriceFilter: 'userPriceFilter',
  modelPriceFilter: 'modelPriceFilter',
  pricePerFilter: 'pricePerFilter',
  wineSiteTypeFilter: 'wineSiteTypeFilter',
  multiCountryFilter: 'multiCountryFilter',
  multiCurrencyFilter: 'multiCurrencyFilter',
  isStockQuantitySetFilter: 'isStockQuantitySetFilter',
  aiFactsFilter: 'aiFactsFilter',
  userFactsFilter: 'userFactsFilter',
  grapesFactFilter: 'grapesFactFilter',
  alcoholFactFilter: 'alcoholFactFilter',
  certsFactFilter: 'certsFactFilter',
  awardsFactFilter: 'awardsFactFilter',
  aiFactsDateFilter: 'aiFactsDateFilter',
  canonicalLinkFilter: 'canonicalLinkFilter',
  isNotOkSnapshotFilter: 'isNotOkSnapshotFilter',
} as const

export const ADMIN_FILTERS_TITLE = {
  userFilter: 'filters.names.users',
  verificationUserFilter: 'filters.names.verificationUser',
  verificatedAtFilter: 'filters.names.verificatedAt',
  creationUserFilter: 'filters.names.creationUser',
  lastUpdateUserFilter: 'filters.names.lastUpdateUser',
  usernameFilter: 'filters.names.user',
  lotAuthorUserFilter: 'filters.names.lotAuthorUser',
  producerFilter: 'filters.names.producer',
  countryFilter: 'filters.names.country',
  wineCountryFilter: 'filters.names.wineCountryFilter',
  diffFieldsFilter: 'filters.names.diffFields',
  statusFilter: 'filters.names.statusFilter',
  verificationFilter: 'filters.names.verificationStatus',
  categoryFilter: 'filters.names.companyCategory',
  stripeIdStatusFilter: 'filters.names.stripeId',
  createdAtFilter: 'filters.names.creationDate',
  aiWineDateFilter: 'filters.names.aiWineDate',
  lotCreatedAtFilter: 'filters.names.lotCreatedAt',
  lastUpdateFilter: 'filters.names.lastUpdate',
  updatedAtFilter: 'filters.names.updatedAt',
  expertQualificationFilter: 'filters.names.expertQualification',
  permissionFilter: 'filters.names.permission',
  expertVerificationStatusFilter: 'filters.names.expertVerificationStatus',
  userStatusFilter: 'filters.names.userStatus',
  merchantFilter: 'filters.names.merchant',
  merchantNameFilter: 'filters.names.merchantName',
  eshopFilter: 'filters.names.eshop',
  productBrandFilter: 'filters.names.brandFilter',
  geoIndicationFilter: 'filters.names.geoIndicationFilter',
  specialClassificationFilter: 'filters.names.specialClassificationFilter',
  nationalGITypeFilter: 'filters.names.nationalGITypeFilter',
  wineRegionEUFilter: 'filters.names.wineRegionEUFilter',
  wineTypeFilter: 'filters.names.wineTypeFilter',
  wineColourFilter: 'filters.names.wineColourFilter',
  sweetnessTypeFilter: 'filters.names.sweetnessTypeFilter',
  vintageFilter: 'filters.names.vintageFilter',
  bottleSizeFilter: 'filters.names.bottleSizeFilter',
  packageTypeFilter: 'filters.names.packageTypeFilter',
  uniqueProductURLFilter: 'filters.names.uniqueProductURL',
  frontLabelFilter: 'filters.names.frontLabel',
  backLabelFilter: 'filters.names.backLabel',
  packshotFilter: 'filters.names.packshot',
  eshopCountryFilter: 'filter.names.eshopCountry',
  alcoholLevelFilter: 'filters.names.alcoholLevelFilter',
  wineLotFilter: 'filters.names.wineLot',
  vatBehaviorFilter: 'filters.names.vatBehavior',
  purchaseConditionFilter: 'filters.names.purchaseCondition',
  deliveryCostFilter: 'filters.names.deliveryCost',
  isMerchantSetFilter: 'filters.names.isMerchantSetFilter',
  isProductSetFilter: 'filters.names.isProductSetFilter',
  isWineSetFilter: 'filters.names.isWineSetFilter',
  merchantCountryFilter: 'filters.names.eshopCountry',
  deliveryTimeFilter: 'filters.names.delivetyTime',
  parsingFilter: 'filters.names.parsing',
  isEshopFilter: 'filters.names.isEshop',
  invalidRecordFilter: 'filters.names.invalidRecord',
  existenceFilter: 'filters.names.existence',
  additionalNameFilter: 'filters.names.additionalName',
  withAdditionalNameFilter: 'filters.names.withAdditionalName',
  confidenceFilter: 'filters.names.confidence',
  isModelWineSetFilter: 'filters.names.isModelWineSet',
  userWineFilter: 'filters.names.userWine',
  authorUserRoleFilter: 'filters.names.userRole',
  isModelUserWineMatchFilter: 'filters.names.isModelUserWineMatch',
  modelVersionFilter: 'filters.names.modelVersion',
  pendingVerificationStepFilter: 'filters.names.pendingVerificationStep',
  clusterMentionFilter: 'filters.names.clusterMention',
  invalidEntityFilter: 'filters.names.invalidEntity',
  hasVerifiedRepresentativeFilter: 'filters.names.producerWWLFilter',
  hasBottleImageFilter: 'filters.names.packshot',
  hasFrontLabelImageFilter: 'filters.names.frontLabel',
  hasBackLabelImageFilter: 'filters.names.backLabel',
  alcoholOnLabelFilter: 'filters.names.alcoholLevelFilter',
  certificatesFilter: 'filters.names.certificatesFilter',
  sourceFilter: 'filters.names.source',
  destinationSourceFilter: 'filters.names.destinationSource',
  authorUserFilter: 'filters.names.authorUser',
  allCheckedFilter: 'filters.names.allChecked',
  checkedStepsFilter: 'filters.names.checkedSteps',
  kindOfWineFilter: 'filters.names.kindOfWine',
  rightnessFilter: 'filters.names.rightness',
  identificationFilter: 'filters.names.identification',
  isPrivilegedFilter: 'filters.names.isPrivileged',
  relationTypeFilter: 'filters.names.relationType',
  authorFilter: 'filters.names.author',
  isModelDisagreeFilter: 'filters.names.isModelDisagree',
  hasImagesFilter: 'filters.names.hasImagesFilter',
  mentionImages: 'filters.names.mentionImages',
  conflictsFilter: 'filters.names.conflicts',
  onlyOldFilter: 'filters.names.onlyOld',
  differentVintagesFilter: 'filters.names.differentVintages',
  userEntitiesFilter: 'filters.names.userEntities',
  aiRetailOffersFilter: 'filters.names.aiRetailOffers',
  userRetailOffersFilter: 'filters.names.userRetailOffers',
  hasTradeOfferDifferenceFilter: 'filters.names.hasTradeOfferDifference',
  anomalyFilter: 'filters.names.anomaly',
  retailOfferStatusFilter: 'filters.names.retailOfferStatus',
  retailOfferSizeFilter: 'filters.names.retailOfferSize',
  retailOfferPackageTypeFilter: 'filters.names.retailOfferPackageType',
  retailOfferWineLotFilter: 'filters.names.retailOfferWineLot',
  retailOfferVatBehaviorFilter: 'filters.names.retailOfferVatBehavior',
  retailOfferPurchaseConditionFilter:
    'filters.names.retailOfferPurchaseCondition',
  retailOfferDeliveryCostFilter: 'filters.names.retailOfferDeliveryCost',
  retailOfferVintageFilter: 'filters.names.retailOfferVintage',
  retailOfferCountFilter: 'filters.names.retailOfferCount',
  retailOfferPriceTypeFilter: 'filters.names.retailOfferPriceType',
  suspiciousStatusFilter: 'filters.names.suspiciousStatus',
  suspiciousBottleSizeFilter: 'filters.names.suspiciousBottleSize',
  suspiciousPackageTypeFilter: 'filters.names.suspiciousPackageType',
  suspiciousWineLotFilter: 'filters.names.suspiciousWineLot',
  suspiciousPriceFilter: 'filters.names.suspiciousPrice',
  suspiciousCurrencyFilter: 'filters.names.suspiciousCurrency',
  suspiciousVatBehaviorFilter: 'filters.names.suspiciousVatBehavior',
  suspiciousPriceTypeFilter: 'filters.names.suspiciousPriceType',
  suspiciousPurchaseConditionFilter:
    'filters.names.suspiciousPurchaseCondition',
  suspiciousDeliveryCostFilter: 'filters.names.suspiciousDeliveryCost',
  suspiciousVintageFilter: 'filters.names.suspiciousVintage',
  suspiciousOfferCountFilter: 'filters.names.suspiciousOfferCount',
  variousQuantitiesFilter: 'filters.names.variousQuantities',
  suspiciousScreenValidityFilter: 'filters.names.suspiciousScreenValidity',
  validScreenFilter: 'filters.names.validScreen',
  onlyLatestMentionFilter: 'filters.names.onlyLatestMentions',
  invalidReasonFilter: 'filters.names.invalidReason',
  modelNewLotsFilter: 'filters.names.modelNewLots',
  userNewLotsFilter: 'filters.names.userNewLots',
  userPriceFilter: 'filters.names.userPrice',
  modelPriceFilter: 'filters.names.aiPrice',
  pricePerFilter: 'filters.names.pricePer',
  wineSiteTypeFilter: 'filters.names.wineSiteType',
  multiCountryFilter: 'filters.names.multiCountry',
  multiCurrencyFilter: 'filters.names.multiCurrency',
  isStockQuantitySetFilter: 'filters.names.isStockQuantitySet',
  aiFactsFilter: 'filters.names.aiFacts',
  userFactsFilter: 'filters.names.userFacts',
  grapesFactFilter: 'filters.names.grapesFact',
  alcoholFactFilter: 'filters.names.alcoholFact',
  certsFactFilter: 'filters.names.certsFact',
  awardsFactFilter: 'filters.names.awardsFact',
  aiFactsDateFilter: 'filters.names.aiFactsDate',
  canonicalLinkFilter: 'filters.names.canonicalLink',
  isNotOkSnapshotFilter: 'filters.names.isNotOkSnapshot',
}
